Dropdowns = LP.module 'Dropdowns'

Dropdowns.toggleOnRemoteLinks = ->
  $('ul.dropdown-menu a[data-remote=true]').click ->
    $(this).closest('ul').prev('button').dropdown 'toggle'
